module.exports = "/_next/static/images/slide2-51b24b77bfd1363587b49a1f30f56ad7.jpg.webp";